module.exports = __webpack_public_path__ + "assets/img/scss_import.b02b2727.jpg";